module.exports = __webpack_public_path__ + "img/Vector5.8191c032.svg";